import React, { ReactElement, ReactNode } from 'react';
import styled from '@emotion/styled';

import { SHARED } from 'shared/constants';
import { MEDIA_QUERY, Theme } from 'theme';

interface DetailsFieldProps {
  background?: string;
  label?: ReactNode;
  value?: ReactNode;
  name?: string;
  dataCy?: string;
  padding?: { v?: number; h?: number };
}
const DetailsFieldLayout = styled.div<{
  theme?: Theme;
  name?: string;
  padding?: { v?: number; h?: number };
  background?: string;
}>`
  ${({ name }) => (name ? `grid-area: ${name};` : 'grid-template-rows: 30px 1fr;')}
  display: grid;
  gap: 8px;
  font-size: 12px;
  font-weight: bold;
  padding: ${({ padding }) => `${padding?.v ?? 20}px ${padding?.h ?? 34}px`};
  background: ${({ theme, background }) => background || theme.colors.mineShaft};
  width: 100%;
  height: 100%;
  min-width: 150px;
  word-break: break-word;

  @media ${MEDIA_QUERY.MAX_XL} {
    margin-bottom: 1px;

    &:last-of-type {
      margin-bottom: 0px;
    }
  }
`;

const DetailsFieldLabel = styled.div<{ theme?: Theme }>`
  font-family: Lato;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.doveGray};
  margin-bottom: 8px;
`;

const DetailsFieldValue = styled.div<{ theme?: Theme }>`
  margin: auto 0;
  color: ${({ theme }) => theme.colors.whisper};
  word-wrap: break-word;
`;

export const DetailsField = ({
  background,
  label,
  value,
  name,
  dataCy,
  padding,
}: DetailsFieldProps): ReactElement => (
  <DetailsFieldLayout background={background} padding={padding} name={name}>
    {label && <DetailsFieldLabel>{label}</DetailsFieldLabel>}
    <DetailsFieldValue data-cy={dataCy}>{value || SHARED.LONG_DASH}</DetailsFieldValue>
  </DetailsFieldLayout>
);
